export default __webpack_public_path__ + "static/media/HeroMontage@xs.7c5c8d51.jpg";